import {Skeleton} from '@mui/material';
import {StyledCard} from 'presentation/components';
import React from 'react';

export function LoadingState() {
	return (
		<StyledCard.Container>
			<Skeleton sx={{width: '100%', borderRadius: 0.5}} />
			<Skeleton sx={{width: '70%', borderRadius: 0.5}} />
			<Skeleton sx={{width: '40%', borderRadius: 0.5}} />
		</StyledCard.Container>
	);
}
